import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as l, normalizeClass as n, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconQrCode",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, i, h, v, a) {
  return d(), l("svg", {
    "aria-label": i.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--qr-code"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Qr Code",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1 2a1 1 0 0 1 1-1h1.5a1 1 0 0 1 1 1v1.5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2Zm2.5 0H2v1.5h1.5V2Zm4 0a1 1 0 0 1 1-1H10a1 1 0 0 1 1 1v1.5a1 1 0 0 1-1 1H8.5a1 1 0 0 1-1-1V2ZM10 2H8.5v1.5H10V2ZM1 8.5a1 1 0 0 1 1-1h1.5a1 1 0 0 1 1 1V10a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V8.5Zm2.5 0H2V10h1.5V8.5Zm4.44-.56A1.5 1.5 0 0 1 9 7.5h1.5a.5.5 0 0 1 0 1H9a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 1-1 0V9c0-.398.158-.78.44-1.06ZM10.5 10a.5.5 0 0 1 .5.5v.005a.5.5 0 0 1-1 0V10.5a.5.5 0 0 1 .5-.5ZM6 3a.5.5 0 0 1 .5.5V5A1.5 1.5 0 0 1 5 6.5H3.5a.5.5 0 0 1 0-1H5a.5.5 0 0 0 .5-.5V3.5A.5.5 0 0 1 6 3ZM1 6a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H1.5A.5.5 0 0 1 1 6Zm4.5-4.5A.5.5 0 0 1 6 1h.005a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5Zm.5 6a.5.5 0 0 1 .5.5v.005a.5.5 0 0 1-1 0V8a.5.5 0 0 1 .5-.5ZM7.5 6a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 0 1H8a.5.5 0 0 1-.5-.5Zm3-.5a.5.5 0 0 1 .5.5v.005a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5ZM6 9.5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-1 0V10a.5.5 0 0 1 .5-.5Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, m);
}
const _ = /* @__PURE__ */ s(c, [["render", u]]);
export {
  _ as default
};
//# sourceMappingURL=qr-code.js.map
